import getNestedPropByID from "../../../../functions/getNestedPropByID";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import { Request_Letter } from "../api/Request_Letter";

function ConsultantLetterCards({
  Arr_Bookings,
  screenWidth,
  obj_EC,
  handleRequestLetter,
  handleOpenVISAPage,
  Arr_ECs,
}) {
  const { logoutConsultant } = ConsultantuseAuth();

  return (
    <div
      class="w3-row-padding w3-center w3-padding-64 w3-theme-l5"
      id="pricing"
    >
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        {Arr_Bookings.map((obj_booking, index) => (
          <div
            class="w3-third w3-margin-bottom"
            style={{
              width: screenWidth === "Small" ? "100%" : "",
            }}
          >
            <ul class="w3-ul w3-border w3-hover-shadow">
              <li class="w3-theme">
                <p class="w3-large">
                  {obj_booking.BasicInfo?.First_Name || ""}{" "}
                  {obj_booking.BasicInfo?.Last_Name || ""}
                  {obj_EC.MetaData?.Admin === "Yes" ? (
                    <>
                      , Booking made by{" "}
                      {getNestedPropByID(
                        Arr_ECs,
                        obj_booking.IPInfo?.EC_ID,
                        "First_Name",
                        "BasicInfo"
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </p>
              </li>
              <li class="w3-padding-16">
                {obj_booking.BasicInfo?.ProgrammeTitle || ""}
              </li>
              <li class="w3-padding-8">
                {obj_booking.BasicInfo?.ProgrammeDate || ""}
              </li>
              <li class="w3-padding-8">
                {" "}
                {obj_booking.BasicInfo?.ProgrammeVarient || ""}
              </li>
              <li class="w3-padding-8">
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <h4
                    style={{
                      backgroundColor: "rgba(209, 18, 18, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Place Cancelled
                  </h4>
                ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                  <h4
                    style={{
                      backgroundColor: "rgba(8, 83, 182, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Place Reserved
                  </h4>
                ) : (
                  <h4
                    style={{
                      backgroundColor: "rgba(6, 134, 47, 0.5)",
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Place Confirmed
                  </h4>
                )}
              </li>

              <>
                <li class="w3-padding-8">
                  <button
                    onClick={(e) => handleOpenVISAPage(e, obj_booking)}
                    style={{
                      width: "70%",
                      textAlign: "center",
                      marginLeft: "15%",
                      marginRight: "15%",
                    }}
                  >
                    Edit VISA Info Page
                  </button>
                  <span class="w3-opacity">
                    Do you require a VISA support letter?:
                  </span>
                  <h3
                    class=""
                    style={{
                      width: "50%",
                      textAlign: "center",
                      marginLeft: "25%",
                      marginRight: "25%",
                    }}
                  >
                    {obj_booking.VISA?.Do_you_require_a_VISA_support_letter ||
                      ""}
                  </h3>
                  <span class="w3-opacity">
                    {obj_booking.VISA?.Do_you_require_a_VISA_support_letter
                      ? "Info:"
                      : ""}
                  </span>
                </li>
                {obj_booking.VISA?.Do_you_require_a_VISA_support_letter ===
                "Yes" ? (
                  <>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA
                        ?.Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK
                        ? "Ever Been Previously Refused: " +
                          obj_booking.VISA
                            ?.Has_the_student_ever_been_refused_a_VISA_for_any_county_including_the_UK
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA
                        ?.Which_country_or_countries_has_the_VISA_been_rejected_from_previously
                        ? "Previously Refused From: " +
                          obj_booking.VISA
                            ?.Which_country_or_countries_has_the_VISA_been_rejected_from_previously
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA
                        ?.When_was_the_last_time_the_students_VISA_was_rejected
                        ? "When were you last refused: " +
                          obj_booking.VISA
                            ?.When_was_the_last_time_the_students_VISA_was_rejected
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA?.Passport_Name
                        ? "Passport Name: " + obj_booking.VISA?.Passport_Name
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA?.Passport_Number
                        ? "Passport Number: " +
                          obj_booking.VISA?.Passport_Number
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA?.Passport_DOB
                        ? "Passport DOB: " + obj_booking.VISA?.Passport_DOB
                        : ""}
                    </li>
                    <li
                      class="w3-padding-8"
                      style={{
                        width: "70%",
                        textAlign: "center",
                        marginLeft: "15%",
                        marginRight: "15%",
                      }}
                    >
                      {obj_booking.VISA?.Passport_Nationality
                        ? "Passport Nationality: " +
                          obj_booking.VISA?.Passport_Nationality
                        : ""}
                    </li>
                    <li class="w3-padding-8">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-around",
                        }}
                      >
                        {obj_booking.MetaData?.Archived === "Yes" ? (
                          <></>
                        ) : obj_booking.VISA?.Passport_Name &&
                          obj_booking.VISA?.Passport_DOB &&
                          obj_booking.VISA?.Passport_Nationality &&
                          obj_booking.VISA?.Passport_Number ? (
                          <button
                            onClick={(e) =>
                              handleRequestLetter(e, "VISA", obj_booking)
                            }
                            style={{ width: "30%" }}
                          >
                            Request VISA Letter
                          </button>
                        ) : (
                          "Please Complete the VISA Info Page"
                        )}

                        <button
                          onClick={(e) =>
                            handleRequestLetter(e, "Acceptance", obj_booking)
                          }
                          style={{ width: "30%" }}
                        >
                          Request Acceptance Letter
                        </button>
                        {/* <button
                          onClick={(e) =>
                            handleRequestLetter(
                              e,
                              "Acceptance_Pay",
                              obj_booking
                            )
                          }
                          style={{ width: "30%" }}
                        >
                          Request Acceptance Letter With Payment Line
                        </button> */}
                      </div>
                    </li>
                  </>
                ) : (
                  <> </>
                )}
              </>
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConsultantLetterCards;
